import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Seed fallback so the page never renders 0/blank if the fetch fails.
export const PRACTICE_FALLBACK = {
  hero: {
    projects: { value: 1000, suffix: '+' },
    cities: { value: 60, suffix: '+' },
    years: { value: 9, suffix: '' },
  },
  india: [],
  international: [],
  images: {},
};

// Single fetch of GET /api/practice/content for the whole /practice page.
// Reused by the hero now and the map section in a later segment.
export function usePracticeContent() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let alive = true;
    axios
      .get(`${BACKEND_URL}/api/practice/content`)
      .then((r) => { if (alive) { setData(r.data); setLoading(false); } })
      .catch(() => { if (alive) { setData(PRACTICE_FALLBACK); setError(true); setLoading(false); } });
    return () => { alive = false; };
  }, []);

  return { data, loading, error };
}
